// import Blogs from "pages/Blogs";
// import FAQs from "pages/FAQs";
import BlogsDetails from "containers/Blogs/BlogsDetail";
import ContactUs from "pages/ContactUs/ContactUs";
import Team from "pages/Team/Team";
import { lazy } from "react";
import { appRoutesConst } from "./navigation";

// Components

// Home Page
const Home = lazy(() => import("../pages/Home/Home"));

// Packages
const Packages = lazy(() => import("../pages/Packages/Packages"));

//Hotels
const Hotels = lazy(() => import("../pages/Hotels/Hotels"));

// Blogs Page
const Blogs = lazy(() => import("../pages/Blogs"));

// FAqs Page
const FAQs = lazy(() => import("../pages/FAQS/FAQS"));

// FAqs Page
const Reviews = lazy(() => import("../pages/Reviews/Reviews"));

// Search Flight Page
const SearchFlight = lazy(() => import("../pages/SearchFlight/SearchFlight"));

// Image Gallary
const ImageGallary = lazy(() => import("../pages/ImageGallary/ImageGallary"));

// video Gallary
const VideoGallary = lazy(() => import("../pages/VideoGallary/VideoGallary"));

const PackagesDetail = lazy(() => import("../pages/Packages/PackagesDetail"));

// terms
const TermsConditionPage = lazy(() =>
  import("../pages/TermsCondition/TermsConditionPage")
);

const PrivacyPolicyPage = lazy(() =>
  import("../pages/PrivacyPolicy/PrivacyPolicyPage")
);

const UmrahPackages  = lazy(() => 
    import("../pages/Umrah/UmrahPacakages")
)

const Nusuk  = lazy(() =>
    import("../pages/Nusuk/Nusuk")
)
const GlobalTour  = lazy(() =>
    import("../pages/GlobalTour/GlobalTour")
)
const GlobalTourDetail  = lazy(() =>
    import("../pages/GlobalTour/GlobalTourDetailPage")
)
const TenYearVisa  = lazy(() =>
    import("../pages/TenYearVisa/TenYearVisa")
)
const TenYearSaudiTouristEVisa  = lazy(() =>
    import("../pages/TenYearSaudiTouristEVisa/TenYearSaudiTouristEVisa")
)
const FiveYearSaudiTouristEVisa  = lazy(() =>
  import("../pages/FiveYearSaudiTouristEVisa/FiveYearSaudiTouristEVisa")
)
const OneYearSaudiTouristEVisa  = lazy(() =>
  import("../pages/OneYearSaudiTouristEVisa/OneYearSaudiTouristEVisa")
)
const Hajj2025  = lazy(() =>
    import("../pages/Hajj2025/Hajj2025")
)
// const Hajj2026  = lazy(() =>
//     import("../pages/Hajj2026/Hajj2026")
// )
const UmrahPackageChicago  = lazy(() =>
    import("../pages/UmrahPackageChicago/UmrahPackageChicago")
)
const UmrahPackageDallas  = lazy(() =>
    import("../pages/UmrahPackageDallas/UmrahPackageDallas")
)
const UmrahPackagePhiladelphia   = lazy(() =>
    import("../pages/UmrahPackagePhiladelphia/UmrahPackagePhiladelphia")
)
const UmrahPackageDearborn  = lazy(() =>
    import("../pages/UmrahPackageDearborn/UmrahPackageDearborn")
)
const UmrahPackageColorado = lazy(() =>
    import("../pages/UmrahPackageColorado/UmrahPackageColorado")
)
const UmrahPackageWashingtonDC = lazy(() =>
    import("../pages/UmrahPackageWashingtonDC/UmrahPackageWashingtonDC")
)
const UmrahRamadanPackages = lazy(() =>
    import("../pages/UmrahRamadanPackages/UmrahRamadanPackages")
)
const UmrahPackageCalifornia = lazy(() =>
    import("../pages/UmrahPackageCalifornia/UmrahPackageCalifornia")
)
const UmrahPackageMichigan = lazy(() =>
    import("../pages/UmrahPackageMichigan/UmrahPackageMichigan")
)
const UmrahPackageNewYork = lazy(() =>
    import("../pages/UmrahPackageNewYork/UmrahPackageNewYork")
)
const UmrahPackageHouston = lazy(() =>
    import("../pages/UmrahPackageHouston/UmrahPackageHouston")
)
const UmrahPackageLosAngeles = lazy(() =>
    import("../pages/UmrahPackageLosAngeles/UmrahPackageLosAngeles")
)
const UmrahPackageAtlantaGA = lazy(() =>
    import("../pages/UmrahPackageAtlantaGA/UmrahPackageAtlantaGA")
)
const UmrahPackagePlanoTX = lazy(() =>
    import("../pages/UmrahPackagePlanoTX/UmrahPackagePlanoTX")
)
const UmrahPackageTampaFL = lazy(() =>
    import("../pages/UmrahPackageTampaFL/UmrahPackageTampaFL")
)
const UmrahPackageSanDiegoCA = lazy(() =>
  import("../pages/UmrahPackageSanDiegoCA/UmrahPackageSanDiegoCA")
)
const UmrahPackageMilwaukeeWI = lazy(() =>
  import("../pages/UmrahPackageMilwaukeeWI/UmrahPackageMilwaukeeWI")
)
const UmrahPackageOrlandoFL = lazy(() =>
  import("../pages/UmrahPackageOrlandoFL/UmrahPackageOrlandoFL")
)
const UmrahPackageMinneapolisMN = lazy(() =>
  import("../pages/UmrahPackageMinneapolisMN/UmrahPackageMinneapolisMN")
)
const payment = lazy(() =>
    import("../pages/Payment/Payment")
)
const julyUmrahPackage = lazy(() =>
    import("../pages/Umrah/Monthly/JulyUmrahPackage/JulyUmrahPackage")
)
const januaryUmrahPackage = lazy(() =>
    import("../pages/Umrah/Monthly/JanuaryUmrahPackage/JanuaryUmrahPackage")
)
const februaryUmrahPackage = lazy(() =>
    import("../pages/Umrah/Monthly/FebruaryUmrahPackage/FebruaryUmrahPackage")
)
const augustUmrahPackage = lazy(() =>
    import("../pages/Umrah/Monthly/AugustUmrahPackage/AugustUmrahPackage")
)
const ramadan1stAshraUmrahPackage = lazy(() =>
  import("../pages/UmrahRamadanPackages/Packages/Ramadan1stAshraUmrahPackage/Ramadan1stAshraUmrahPackage")
)
const ramadan2ndAshraUmrahPackage = lazy(() =>
  import("../pages/UmrahRamadanPackages/Packages/Ramadan2ndAshraUmrahPackage/Ramadan2ndAshraUmrahPackage")
)
const ramadan3rdAshraUmrahPackage = lazy(() =>
  import("../pages/UmrahRamadanPackages/Packages/Ramadan3rdAshraUmrahPackage/Ramadan3rdAshraUmrahPackage")
)
const septemberUmrahPackage = lazy(() =>
    import("../pages/Umrah/Monthly/SeptemberUmrahPackage2026/SeptemberUmrahPackage")
)
const octoberUmrahPackage = lazy(() =>
    import("../pages/Umrah/Monthly/OctoberUmrahPackage2026/OctoberUmrahPackage")
)
const novemberUmrahPackage = lazy(() =>
    import("../pages/Umrah/Monthly/NovemberUmrahPackage/NovemberUmrahPackage")
)
const decemberUmrahPackage = lazy(() =>
    import("../pages/Umrah/Monthly/DecemberUmrahPackage/DecemberUmrahPackage")
)
// eslint-disable-next-line import/no-anonymous-default-export
export default [
  {
    path: appRoutesConst.index,
    element: Home,
    isOpenRoute: true,
  },

  // package routes
  {
    path: appRoutesConst.packages,
    element: Packages,
    isOpenRoute: true,
  },
  {
    path: appRoutesConst.packagesDetails,
    element: PackagesDetail,
    isOpenRoute: true,
    exact: true,
  },

  // hotels routes
  {
    path: appRoutesConst.hotels,
    element: Hotels,
    isOpenRoute: true,
  },

  //faqs routes
  {
    path: appRoutesConst.faqs,
    element: FAQs,
    isOpenRoute: true,
  },

  // blog routes
  {
    path: appRoutesConst.blogs,
    element: Blogs,
    isOpenRoute: true,
  },
  {
    path: appRoutesConst.blogDetails,
    element: BlogsDetails,
    isOpenRoute: true,
  },
  //  blog routes
  {
    path: appRoutesConst.reviews,
    element: Reviews,
    isOpenRoute: true,
  },
  //  search flight
  {
    path: appRoutesConst.searchflight,
    element: SearchFlight,
    isOpenRoute: true,
  },
  //images gallary
  {
    path: appRoutesConst.imagesGallary,
    element: ImageGallary,
    isOpenRoute: true,
  },
  {
    path: appRoutesConst.images,
    element: ImageGallary,
    isOpenRoute: true,
  },

  //videos gallary
  {
    path: appRoutesConst.videosGallary,
    element: VideoGallary,
    isOpenRoute: true,
  },
  {
    path: appRoutesConst.videos,
    element: VideoGallary,
    isOpenRoute: true,
  },

  // contact us
  {
    path: appRoutesConst.contactus,
    element: ContactUs,
    isOpenRoute: true,
  },
  // terms
  {
    path: appRoutesConst.termsandconditions,
    element: TermsConditionPage,
    isOpenRoute: true,
  },
  // team
  {
    path: appRoutesConst.team,
    element: Team,
    isOpenRoute: true,
  },
  {
    path: appRoutesConst.privacypolicy,
    element: PrivacyPolicyPage,
    isOpenRoute: true,
  },

  {
    path: appRoutesConst.umrahpackages,
    element: UmrahPackages,
    isOpenRoute: true,
  },{
    path: appRoutesConst.nusuk,
    element: Nusuk,
    isOpenRoute: true,
  },{
    path: appRoutesConst.globalTour,
    element: GlobalTour,
    isOpenRoute: true,
  },
  {
    path: appRoutesConst.globalTourDetail,
    element: GlobalTourDetail,
    isOpenRoute: true,
  },

  {
    path: appRoutesConst.tenYearVisa,
    element: TenYearVisa,
    isOpenRoute: true,
  },
  {
    path: appRoutesConst.tenYearSaudiTouristEVisa,
    element: TenYearSaudiTouristEVisa,
    isOpenRoute: true,
  },
  {
    path: appRoutesConst.fiveYearSaudiTouristEVisa,
    element: FiveYearSaudiTouristEVisa,
    isOpenRoute: true,
  },
  {
    path: appRoutesConst.oneYearSaudiTouristEVisa,
    element: OneYearSaudiTouristEVisa,
    isOpenRoute: true,
  },
  // {
  //   path: appRoutesConst.hajj2026,
  //   element: Hajj2026,
  //   isOpenRoute: true,
  // },
  {
    path: appRoutesConst.hajj2025,
    element: Hajj2025,
    isOpenRoute: true,
  },
  {
    path: appRoutesConst.umrahPackageChicago,
    element: UmrahPackageChicago,
    isOpenRoute: true,
  },
  {
    path: appRoutesConst.umrahPackageDallas,
    element: UmrahPackageDallas,
    isOpenRoute: true,
  },
  {
    path: appRoutesConst.umrahPackagePhiladelphia,
    element: UmrahPackagePhiladelphia,
    isOpenRoute: true,
  },
  {
    path: appRoutesConst.umrahPackageDearborn,
    element: UmrahPackageDearborn,
    isOpenRoute: true,
  },
  {
    path: appRoutesConst.umrahPackageCalifornia,
    element: UmrahPackageCalifornia,
    isOpenRoute: true,
  },
  {
    path: appRoutesConst.umrahPackageColorado,
    element: UmrahPackageColorado,
    isOpenRoute: true,
  },
  {
    path: appRoutesConst.umrahPackageMichigan,
    element: UmrahPackageMichigan,
    isOpenRoute: true,
  },
  {
    path: appRoutesConst.umrahPackageNewYork,
    element: UmrahPackageNewYork,
    isOpenRoute: true,
  },
  {
    path: appRoutesConst.umrahPackageHouston,
    element: UmrahPackageHouston,
    isOpenRoute: true,
  },
  {
    path: appRoutesConst.umrahPackageLosAngeles,
    element: UmrahPackageLosAngeles,
    isOpenRoute: true,
  },
  {
    path: appRoutesConst.umrahPackageAtlantaGA,
    element: UmrahPackageAtlantaGA,
    isOpenRoute: true,
  },
  {
    path: appRoutesConst.umrahPackagePlanoTX,
    element: UmrahPackagePlanoTX,
    isOpenRoute: true,
  },
  {
    path: appRoutesConst.umrahPackageOrlandoFL,
    element: UmrahPackageOrlandoFL,
    isOpenRoute: true,
  },
  {
    path: appRoutesConst.umrahPackageSanDiegoCA,
    element: UmrahPackageSanDiegoCA,
    isOpenRoute: true,
  },
  {
    path: appRoutesConst.umrahPackageTampaFL,
    element: UmrahPackageTampaFL,
    isOpenRoute: true,
  },
  {
    path: appRoutesConst.umrahPackageMinneapolisMN,
    element: UmrahPackageMinneapolisMN,
    isOpenRoute: true,
  },
  {
    path: appRoutesConst.umrahPackageMilwaukeeWI,
    element: UmrahPackageMilwaukeeWI,
    isOpenRoute: true,
  },
  {
    path: appRoutesConst.umrahPackageWashingtonDC,
    element: UmrahPackageWashingtonDC,
    isOpenRoute: true,
  },
  {
    path: appRoutesConst.umrahRamadanPackages,
    element: UmrahRamadanPackages,
    isOpenRoute: true,
  },
  {
    path: appRoutesConst.payment,
    element: payment,
    isOpenRoute: true,
  },
  {
    path: appRoutesConst.julyUmrahPackage,
    element: julyUmrahPackage,
    isOpenRoute: true,
  },
  {
    path: appRoutesConst.januaryUmrahPackage,
    element: januaryUmrahPackage,
    isOpenRoute: true,
  },
  {
    path: appRoutesConst.februaryUmrahPackage,
    element: februaryUmrahPackage,
    isOpenRoute: true,
  },
  {
    path: appRoutesConst.augustUmrahPackage,
    element: augustUmrahPackage,
    isOpenRoute: true,
  },
  {
    path: appRoutesConst.ramadan1stAshraUmrahPackage,
    element: ramadan1stAshraUmrahPackage,
    isOpenRoute: true,
  },
  {
    path: appRoutesConst.ramadan2ndAshraUmrahPackage,
    element: ramadan2ndAshraUmrahPackage,
    isOpenRoute: true,
  },
  {
    path: appRoutesConst.ramadan3rdAshraUmrahPackage,
    element: ramadan3rdAshraUmrahPackage,
    isOpenRoute: true,
  },
  {
    path: appRoutesConst.septemberUmrahPackage,
    element: septemberUmrahPackage,
    isOpenRoute: true,
  },
  {
    path: appRoutesConst.octoberUmrahPackage,
    element: octoberUmrahPackage,
    isOpenRoute: true,
  },
  {
    path: appRoutesConst.novemberUmrahPackage,
    element: novemberUmrahPackage,
    isOpenRoute: true,
  },
  {
    path: appRoutesConst.decemberUmrahPackage,
    element: decemberUmrahPackage,
    isOpenRoute: true,
  },
];
